import React, { Component } from 'react'
import { Tabs, Tab, Spinner } from 'react-bootstrap';
import styles from '../../Css/ShootDetails/ShootDetails.module.css'
import Styles from '../../Css/Hotspot/Hotspot.module.css'
import centralAPI from '../../CentralAPIHandler/CentralAPIHandler';
import { sliderSettings, URLvalidatorOptions } from './HotSpotConfig'
import HotSpotBriefView from './HotSpotBriefView';
import HotSpotAddDetails from './HotSpotAddDetails';
import HotspotImageTabView from './HotspotImageTabView';
import validator from 'validator'
import HotSpotLoadingPage from './HotSpotLoadingPage'
import alertify from 'alertifyjs';
import HotSpotChildComponentLoading from './HotSpotChildComponentLoading';

// redux and dispatch/action controller
import {
    updateCurrentImage,
    updateHotspot,
    updateWholeHotSpotMapObj,
    updateCurrentHotSpotId,
    upateSyncHotSpotTitleDescURL,
    updateWholeSyncHotSpotTitleDescURL,
    updateProjectIdAndSkuId
} from '../../Redux/Reducers/HotspotEditReducer/HotspotEditActionController'
import {connect} from 'react-redux'


class HotspotEdit extends Component {

    constructor(props){
        super(props)
        this.state={
            skuName: "",
            imageListExterior:[],
            imageListInterior:[],
            is360: false,
            activeTab: 'interior',
            isExterior: false,
            isInterior: false,
            isPaid: false,
            // addOrUpdateHotspot: {
            //     imgId: '',
            //     hotSpotObj: {}
            // },
            hotSpotData : {
                isAnyHotSpotSelected : false
            },
            hotSpotDesc : {
                desc:React.createRef(),
                url:React.createRef()
            },
            saveInProgress : false,
            loading: true,
            imageUploadInprogress : false,
            forceReRenderBriefView: true
        };
        this.ref = React.createRef();
        this.hotSpotDescRefs = {
            desc:React.createRef(),
            url:React.createRef()
        };
        this.checkRemovalOfLiRef = null // run func of child from parent

    }
    
    componentDidMount = () => {
        try {

            const {projectId, skuId} = this.setProjectIdAndSkuIdInStore();

            if(!projectId || !skuId) this.handleRedirectToAppDashboard();

            this.getUserData(projectId, skuId);

            this.props.updateProjectIdAndSkuId(projectId, skuId);
        } catch (error) {
            //console.log(error);
        }

    }

    /**
     * Return project id and sku id from URL path
     * @returns 
     */
    setProjectIdAndSkuIdInStore = ()=>{
        try {
            const queryParams = new URLSearchParams(window.location.search);
            const projectId = queryParams.get('project_id');
            const skuId = queryParams.get('sku_id');
            return {projectId, skuId}
        } catch (error) {
            //console.log(error);
        }
    }


    /**
     * On mounting, show loading screen and fetch user data
     */
    getUserData = async (projectId, skuId) => {


        try{

            // check if user logged in, auth_key present in cookies
            const cookie = key=>((new RegExp((key || '=')+'=(.*?); ','gm')).exec(document.cookie+'; ') ||['',null])[1];
            let auth_key = cookie('auth_token')
           
            if(!auth_key) this.handleRedirectToAppDashboard();

            // endpoint and params for get req
            let apiURL = `${process.env.REACT_APP_CLIPPER_PROJ_PREFIX}/v2/dashboard/get-sku-image-list`;
            let apiParams = {
                sku_id: skuId,
                project_id: projectId
            };

            let data  = await centralAPI.handleGetRequest(apiURL, apiParams);
            let dbData = data['data'];

            const allImageIDs = dbData['images_list'].map(imgObj=>imgObj['image_id']);
            //console.log('allImageIDs', allImageIDs);
           
            let tempImgListExt = [...dbData['images_list'].filter( imgData=>( imgData['image_category'].toLowerCase() ).match(/exterior/mg) )];
            let tempImgListInt = [...dbData['images_list'].filter( imgData=>( imgData['image_category'].toLowerCase()==='360int' ) )];

            // set states
            this.setState({
                ...this.state,
                imageListExterior : tempImgListExt,
                skuName: dbData['sku_name'],
                is360 : (dbData['is_360']==="true")?true:false,
                activeTab : (dbData['shoot_type']).toLowerCase(),
                imageListInterior : tempImgListInt,
                isPaid : (dbData['paid_status']==="true")?true:false,         
                isExterior : tempImgListExt.length ? true : false,
                isInterior : tempImgListInt.length ? true : false,  
            });


            //console.log(this.state.imageListExterior)
            //this.updateCurrImgAndRefOnPageLoad();

            let hotSpotMapURL = `${process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX}/api/v1/hotspot/get-hotspots?`;
            let mapping = await centralAPI.handleGetRequest(hotSpotMapURL,{
                imageIDs: [...allImageIDs]
            });

            //console.log('mapping', mapping);

            if(mapping)
                this.setHotSpotMapObjInStore(mapping);

        }catch(err){
            // handle redirection if reject hppns after API call
            //console.log(err);
            this.handleRedirectToAppDashboard();
        }
    }

    /**
     * Create hotspot mapping, if isHidden is false
     * and hotSpotMap
     * @param {*} mapping 
     */
    setHotSpotMapObjInStore = (mapping)=>{
        try {
            //console.log(mapping.hotspots);

            const newHotSpotMapObj = new Map();
            const newSyncHotSpotTitleDescURL = new Map();
    
            /**
             * imageId use as map key, if isHidden is false
             * 
             * if the hotSpots array contains elements, put them under this imageId,
             * else leave as it is
             * 
             */
    
            mapping.hotspots.forEach((element)=>{
                const {imageId, isHidden, hotSpotArray} = element[0];

                const newImageHotSpots = new Map();
                //console.log('element',element)
                if(!isHidden){    
                    hotSpotArray.forEach(hotSpot=>{
                        //const {_id}= hotSpot;
                        newImageHotSpots.set(hotSpot.hotSpotId, {...hotSpot});

                        if(!newSyncHotSpotTitleDescURL.has(hotSpot.hotSpotId)){
                            const titleDescURL = {
                                'title': hotSpot.hotSpotTitle,
                                'desc' : hotSpot.hotSpotDesc,
                                'url' : hotSpot.hotSpotURL,
                                'closeUpURL': hotSpot.hotSpotCloseUpURL
                            };

                            newSyncHotSpotTitleDescURL.set(hotSpot.hotSpotId, titleDescURL);
                        }
                    });
                }

                newHotSpotMapObj.set(imageId, {isHidden,imageHotSpots:newImageHotSpots});
    
            });

            //console.log('newHotSpotMapObj',newHotSpotMapObj);
            
            this.props.updateWholeSyncHotSpotTitleDescURL(newSyncHotSpotTitleDescURL);
            this.props.updateWholeHotSpotMapObj(newHotSpotMapObj);

            // load the original content and set loading page to false
            this.setState({
                ...this.state,
                loading: false
            })
        } catch (error) {
            //console.log(error);

            this.setState({
                ...this.state,
                loading: false
            })
        }
    }

    /**
     * Go back to app dashboard project
     */
    handleRedirectToAppDashboard = ()=>{
        // het userId and enterpriseId from cookie
        // check if user logged in, auth_key present in cookies
        const cookie = key=>((new RegExp((key || '=')+'=(.*?); ','gm')).exec(document.cookie+'; ') ||['',null])[1];
        let userId = cookie('userId');
        let enterpriseId = cookie('enterpriseId');
        let newURL = `${process.env.REACT_APP_APP_DASHBOARD_PROJ_PREFIX}/dashboard/enterprises`;

        if(userId && enterpriseId){
            newURL = `${process.env.REACT_APP_APP_DASHBOARD_PROJ_PREFIX}/dashboard/enterprises/projects?userId=${userId}&enterpriseId=${enterpriseId}`
        }

        // redirect to new url
        window.location.href = newURL;

    }

    updateIsAnyHotSpotSelected = (hotSpotSelectionBool)=>{
        
        if(hotSpotSelectionBool === this.state.hotSpotData.isAnyHotSpotSelected) return;
        //console.log('called');
        this.setState({
            ...this.state,
            hotSpotData: {
                isAnyHotSpotSelected : hotSpotSelectionBool || false
            }
        })
        
    }


    /**
     * onBlur event handler
     * @param {*} e 
     * @returns 
     */
    handleUpdateDescURLHotspot2 = (e)=>{
        try {
            
            //this.resetError();

            //var code = (e.keyCode ? e.keyCode : e.which);
            // if(code === 13) { 
                //Enter keycode
                // update hotspot

                if(!this.props.hotSpotId || !this.props.currentHotSpotObj){
                    alertify.error('Please add or select hotspot image first');
                    return;
                }

                let hotSpotDescTrimmed = this.hotSpotDescRefs.desc.current.value.trim();
                let hotSpotURLTrimmed = this.hotSpotDescRefs.url.current.value.trim();
                
                if(hotSpotDescTrimmed.length<1) {
                    alertify.error('Description cannot be blank or just spaces');
                    return;
                }

                if(this.hotSpotDescRefs.url.current.value && !validator.isURL(hotSpotURLTrimmed, URLvalidatorOptions)){
                    alertify.error(`Either URL is invalid or it doesn't match our criteria`);
                    return;
                }
                
                // update hotspot desc here
                // let hotSpotId= this.props.hotSpotId;

                // let imageId = hotSpotId.split('_');
                // imageId[imageId.length-1] = "";
                // imageId = imageId.join("");
                // let currentHotSpotObj = this.props.hotSpotMapObj.get(`${imageId}`).imageHotspots.get(`${hotSpotId}`)

                // let hotSpotJSON = {
                //     ...currentHotSpotObj,
                //     hotSpotDesc : this.state.hotSpotDesc.desc,
                //     hotSpotURL: this.state.hotSpotDesc.url,
                //     timestamp: {
                //         ...currentHotSpotObj.timestamp,
                //         updatedOn: Date.now()
                //     }
                // }

                // this.props.updateHotspot(hotSpotJSON, imageId);

                let newHotSpotMapObj = new Map(this.props.hotSpotMapObj);

                let mapKeys = [...newHotSpotMapObj.keys()];
                //let hotSpotKeys = [...this.state.hotSpotObj.keys()];


                let hotSpotId =this.props.hotSpotId;

                const descToUpdate = this.hotSpotDescRefs.desc.current.value;
                const urlToUpdate = this.hotSpotDescRefs.url.current.value;
                mapKeys.forEach((key, index)=>{
                    // if hotspot id is there, update title for it

                    try {
                        if( newHotSpotMapObj.get(key).imageHotSpots &&  newHotSpotMapObj.get(key).imageHotSpots.has(hotSpotId) ) {     
                            newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotId).hotSpotDesc = descToUpdate;
                            newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotId).hotSpotURL = urlToUpdate;


                            // sync title and closeUpURL
                            if(this.props.syncHotSpotTitleDescURL.has(hotSpotId)){
                                let titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotId);
                                newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotId).hotSpotTitle = titleDescURL.title ? titleDescURL.title : '';
                                newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotId).hotSpotCloseUpURL = titleDescURL.closeUpURL ? titleDescURL.closeUpURL : '';
                            }

                        }            
                    } catch (error) {
                        throw error;
                    }


                });

                // finally update whole hotSpotMap obj in store
                this.props.updateWholeHotSpotMapObj(newHotSpotMapObj);

                // update syncHotSpotTitleDescURL for this hotspot id
                // get this from props and check if key is there

                let titleDescURL = null;

                if(this.props.syncHotSpotTitleDescURL.has(hotSpotId)){
                    titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotId);

                    titleDescURL.desc = descToUpdate;
                    titleDescURL.url = urlToUpdate;

                    this.props.upateSyncHotSpotTitleDescURL(hotSpotId, titleDescURL);
                }

                if(!titleDescURL){
                    titleDescURL = {
                        title : '', // worst case as title should have been updated
                        desc: descToUpdate,
                        url: urlToUpdate,
                        closeUpURL: ''
                    };

                    this.props.upateSyncHotSpotTitleDescURL(hotSpotId, titleDescURL);
                }

                //console.log('newHotSpotMapObj',newHotSpotMapObj);
                alertify.success('Hot Spot Description and URL updated. Make sure to Save Changes');

            // }

        } catch (error) {
            //this.setError(error || 'Unknown Error Occurred') 
            //console.log(error);
        }
    }

    /**
     * 
     * @todo: remove li inside HotSpotAddDetails if that was the last hotspot
     * Logic removes single hotspot
     * @param {*} e 
     * @returns 
     */
    handleSingleHotSpotRemoval = async (e)=>{
        try {
            // check for hotspot id in props

            let hotSpotId = this.props.hotSpotId ? this.props.hotSpotId : '';

            if(!hotSpotId) {
               alertify.error('Select hotspot to delete.');
               return;
            }

            // we have current hotspot id as well as current image id, remove hotspot from there

            if(this.props.currentImgObj && this.props.currentImgObj.image_id){
                let imgId = this.props.currentImgObj.image_id;
                if(!this.props.hotSpotMapObj.has(imgId)) {
                    alertify.error('Unknown error occurred. Reload the page and try again')
                    throw new Error('CurrentImageObj not available in store');
                };

                this.props.hotSpotMapObj.get(imgId).imageHotSpots.delete(hotSpotId);

                // remove current hotspotid from prop
                //this.props.updateCurrentHotSpotId('');
                // update the hotspotmapobj in store
                this.props.updateWholeHotSpotMapObj(this.props.hotSpotMapObj);

                // as we assigned a func to it
                if(this.checkRemovalOfLiRef) {
                    await this.checkRemovalOfLiRef();
                    // render brief view
                    this.setState({...this.state, forceReRenderBriefView: !this.state.forceReRenderBriefView})
                }

            }
        } catch (error) {
            //console.log(error);
        }
    }


    validateHotSpotMapObj = ()=>{
        try {
            if(this.props.hotSpotMapObj && this.props.hotSpotMapObj.size>0){
                const imageKeys = [...this.props.hotSpotMapObj.keys()];


                for(let i=0; i<imageKeys.length; i++){
                    // get all the hotspot ids, loop thru and check for hotspot title and all
                    const imgObj = this.props.hotSpotMapObj.get(imageKeys[i]);


                    const imageHotSpotKeys = (imgObj.imageHotSpots && imgObj.imageHotSpots.size > 0 ) ? 
                                                [...imgObj.imageHotSpots.keys()] : [];
                    
                    if(!imageHotSpotKeys) continue;

                    // use for loop as we want to break as soon as we get invalid input
                    for(let j=0; j<imageHotSpotKeys.length; j++){
                            const hotSpotObj = imgObj.imageHotSpots.get(imageHotSpotKeys[j]);

                            // check for valid Title, desc and URL if any

                            const hotSpotTitle = hotSpotObj.hotSpotTitle ? hotSpotObj.hotSpotTitle.trim() : '';
                            const hotSpotDesc = hotSpotObj.hotSpotDesc ? hotSpotObj.hotSpotDesc.trim() : '';
                            const hotSpotURL = hotSpotObj.hotSpotURL ? validator.isURL(hotSpotObj.hotSpotURL.trim(), URLvalidatorOptions) : true;

                            // console.log({
                            //     hotSpotTitle,
                            //     hotSpotDesc,
                            //     hotSpotURL 
                            // })

                        if( !hotSpotTitle ||  !hotSpotDesc || !hotSpotURL ) {
                            //console.log('hotSpotObj',hotSpotObj)
                            return false;
                        }
                    }
                    
                }

                return true;
            }
        } catch (error) {
            //console.log(error);
        }

        return false;
    }
    /**
     * 
     * @param {*} e 
     */
    handleSaveToDB = async(e)=>{
        try {
            e.stopPropagation();
            e.preventDefault();

            // submit present state to BE

            // structure to follow for hotSpotMapObj present in store 

            /**
             * 
             * hotSpots : [
             * 
             *  // for each key in map obj, image/frame
             * {
             *      'imageId' : imageId,
             *      'hotSpotArray' : [
             *                          [ { hotSpot1}, {hotSPot2}, {...etc} ]
             *                       ]
             * }
             *  
             * 
             *  {
             *      [
             *          // same for image2 and so on
             *      ]
             * }
             * 
             * ]
             * 
             */

            if( !this.props.hotSpotMapObj || !this.props.hotSpotMapObj.size) {
                alertify.error('Please create hotspot before saving');
                return;
            }

            if(!this.validateHotSpotMapObj()){
                alertify.error('Please make sure all titles and descriptions are filled and URLs are valid');
                return;
            }

            this.setState({
                ...this.state,
                saveInProgress : true
            })

            let hotSpotObjToSend = [];

            let keysInHotSpotMapObj = [...this.props.hotSpotMapObj.keys()];

            let totalNumberOfHotSpots = 0;

            keysInHotSpotMapObj.forEach((key,index)=>{
                // for each key (image/frame), create an array of hotSpots for this frame
                // and push it to hotSpotObjToSend

                let imageObject = this.props.hotSpotMapObj.get(key);

                //console.log('imageObject',imageObject);
                let hotSpotsInThisFrame = ( imageObject.imageHotSpots && imageObject.imageHotSpots.size ) ?
                                            [...imageObject.imageHotSpots.values()] : [];

                totalNumberOfHotSpots = totalNumberOfHotSpots + hotSpotsInThisFrame.length;

                const imageObjectToSend = {
                    imageId: key,
                    hotSpotArray: hotSpotsInThisFrame
                }
                
                hotSpotObjToSend.push(imageObjectToSend);
                // now for each key in imageObject, push it to hotSpotsInThisFrame
            });

            //console.log('hotSpotObjToSend',hotSpotObjToSend);

            // send to DB, and wait for response, add maybe a spinner to show loading

            // if anyhow skuid isn't in store (worst case)
            if(!this.props.projectIdAndSkuId || !this.props.projectIdAndSkuId.projectId || !this.props.projectIdAndSkuId.skuId) {
                this.setProjectIdAndSkuIdInStore();
            }

            // check if user logged in, auth_key present in cookies
            const cookie = key=>((new RegExp((key || '=')+'=(.*?); ','gm')).exec(document.cookie+'; ') ||['',null])[1];
            let auth_key = cookie('auth_token')
                       
            if(!auth_key) {
                alertify.error('Login to save your changes');
                this.setState({...this.state,saveInProgress : false});
                return;
            };

            let url = `${process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX}/api/v1/hotspot/add-hotspots`;
            let body = {
                auth_key: auth_key,
                hotSpotObj: hotSpotObjToSend,
                hotSpotAdditionalDetails: {
                    projectId: this.props.projectIdAndSkuId.projectId,
                    skuId: this.props.projectIdAndSkuId.skuId,
                    totalNumberOfHotSpots
                }
            }
            await centralAPI.handlePostRequest(url, body);

            //console.log(data);
            alertify.success('Hot Spots save to DB successful')

        } catch (error) {
            let errMsg = 'Hot Spot save unsuccessful. '
            if(error && error.message && error.message.match(/401/gmi)){
                errMsg+=`'Unauthorized access'. Please go back and login again.`
            }
            alertify.error(errMsg)
            
            //console.log(error);
        }

        this.setState({
            ...this.state,
            saveInProgress : false
        })

    }

    /**
     * handle image upload
     * @param {*} e  
     * @returns 
     */
 handleImageChoice = async(e) => {
    try {

        if(!this.props.hotSpotId || !this.props.currentHotSpotObj){
            alertify.error('Please add or select a hotspot before choosing image');
            return;
        }
        const file = e.target.files[0];
        if( !file ) return;
    
        // check if user logged in, auth_key present in cookies
        const cookie = key=>((new RegExp((key || '=')+'=(.*?); ','gm')).exec(document.cookie+'; ') ||['',null])[1];
        let auth_key = cookie('auth_token')
                       
        if(!auth_key) {
            alertify.error('Login to upload images');
            return;
        };

        const formData = new FormData();

        this.setState({...this.state, imageUploadInprogress: true})
        // check if image already exists for this one, if yes, send that imagename and delete it, then upload new one
        let existingFileName = null;
        let titleDescURL = null;
        if(this.props.syncHotSpotTitleDescURL.has(this.props.hotSpotId)){
            titleDescURL = this.props.syncHotSpotTitleDescURL.get(this.props.hotSpotId);
        }

        if(titleDescURL && titleDescURL.closeUpURL){
            existingFileName = titleDescURL.closeUpURL.split('/');
            existingFileName = existingFileName[existingFileName.length-1];
        }

        if(existingFileName){
            formData.append('fileName',existingFileName);
        }

        formData.append('auth_key', auth_key);
        
        for(let i=0;i<e.target.files.length;i++){
            formData.append('file', e.target.files[i], e.target.files[i].name);
        }
        
        const url = `${process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX}/api/v1/hotspot/add-hotspot-focus-shoot-image`;
        const res = await centralAPI.handlePostRequest(url, formData)

        if(res && res.files && res.files.length){
            const newFileName = res.files[0]['fd'];
            const closeUpURL = `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/hotspot-focus-shoot/${newFileName}`;

            // set this url for all images with that hotspot id
            let newHotSpotMapObj = new Map(this.props.hotSpotMapObj);

            let mapKeys = [...newHotSpotMapObj.keys()];
            //let hotSpotKeys = [...this.state.hotSpotObj.keys()];


            let hotSpotId =this.props.hotSpotId;

            mapKeys.forEach((key, index)=>{
                // if hotspot id is there, update title for it

                try {
                    if( newHotSpotMapObj.get(key).imageHotSpots &&  newHotSpotMapObj.get(key).imageHotSpots.has(hotSpotId) ) {     
                        newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotId).hotSpotCloseUpURL = closeUpURL;

                        // sync title desc and url
                        if(this.props.syncHotSpotTitleDescURL.has(hotSpotId)){
                            let titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotId);
                            newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotId).hotSpotTitle = titleDescURL.title ? titleDescURL.title : '';
                            newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotId).hotSpotDesc = titleDescURL.desc ? titleDescURL.desc : '';
                            newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotId).hotSpotURL = titleDescURL.url ? titleDescURL.url : '';
                        }

                    }            
                } catch (error) {
                    throw error;
                }


            });

            // finally update whole hotSpotMap obj in store
            this.props.updateWholeHotSpotMapObj(newHotSpotMapObj);

            // update syncHotSpotTitleDescURL for this hotspot id
            // get this from props and check if key is there

            let titleDescURL = null;

            if(this.props.syncHotSpotTitleDescURL.has(hotSpotId)){
                titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotId);
                titleDescURL.closeUpURL = closeUpURL;
                this.props.upateSyncHotSpotTitleDescURL(hotSpotId, titleDescURL);
            }

            if(!titleDescURL){
                titleDescURL = {
                    title : '', // worst case as title should have been updated
                    desc: '',
                    url: '',
                    closeUpURL: closeUpURL
                };

                this.props.upateSyncHotSpotTitleDescURL(hotSpotId, titleDescURL);
            }


            alertify.success('Hot Spot close up image updated. Make sure to Save Changes');
        }

        this.setState({...this.state, imageUploadInprogress: false, forceReRenderBriefView: !this.state.forceReRenderBriefView})
    } catch (error) {
        let errMsg = 'Image upload unsuccessful. '
        if(error && error.message && error.message.match(/401/gmi)){
            errMsg+=`'Unauthorized access'. Please go back and login again.`
        }
        alertify.error(errMsg)
    }

    document.getElementById('hotSpotFocusShoot').value = "";
    this.setState({...this.state, imageDeletionLoading: false,imageUploadInprogress: false});
}


    render() {
        return (
            <div >
                {
                    this.state.loading ? <HotSpotLoadingPage className={[Styles['hotspot-area'],''].join(' ')} />

                    :
                <>
                
                <div className={[Styles['hotspot-area'],''].join(' ')} >
                    <div className={[styles['shoot-back-row'],'row'].join(' ')}>
                            <div className={[styles['shoot-area'],'col-md-12'].join(' ')}>
                                <div className={[styles['shoot-heading'],'row'].join(' ')}>
                                    <div className={[styles['total-shoot'],'col-md-6 d-flex'].join(' ')}>
                                        <p className={styles["back"]} onClick={() => this.handleRedirectToAppDashboard()}>
                                            <span> &larr; </span>
                                             Back
                                        </p>
                                    </div>
                                </div> 
                            </div>
                        </div>

                    <div  className={[styles[''],'container-fluid'].join(' ')}>

                        <div  className={[styles['mainContainerHotSpotEditDiv'],'row'].join(' ')} >

                            <div className={[Styles['hotspot-add'],'col-md-5'].join(' ')}>
                                <div className={[styles['shoot-single-card'],'row m-0'].join(' ')}> 

                                    <HotSpotBriefView 
                                        skuName={this.state.skuName || 'XXX'} 
                                        isPaid={this.state.isPaid || false} 
                                        is360={this.state.is360 || false} 
                                        imgObj = { 
                                            this.state.isExterior ? (this.state.imageListExterior[0]) :( this.state.isInterior ? this.state.isInterior[0]: {})
                                        }
                                        forceReRenderBriefView={this.state.forceReRenderBriefView}
                                    />

                                    <HotSpotAddDetails hotSpotDescRefs={this.hotSpotDescRefs} setCheckRemovalOfLiRef={checkRemovalOfLiRef => this.checkRemovalOfLiRef = checkRemovalOfLiRef}/>


                                </div>
                            </div>

                            <div className={[Styles['hotspot-view'],'col-md-7 text-center hotspot-view'].join(' ')}>

                                <div className={[Styles['tab-content-custom']]}>
                                    <span className={[Styles['hotspot-btns']]}>
                                        <button className={[Styles['remove-hotspot']]} onClick={this.handleSingleHotSpotRemoval}>Remove hotspot from frame</button>
                                        {
                                            this.state.saveInProgress ? (
                                                <button className={[Styles['save-changes']]} disabled={true}><Spinner animation="border" variant="warning" size="sm"/></button>
                                            ) : (<button className={[Styles['save-changes']]} onClick={this.handleSaveToDB}>Save changes</button>)
                                        }   
                                    </span>

                                    <Tabs
                                        defaultActiveKey= {
                                            (this.state.isExterior ) ? ("exterior") : ("interior")
                                        }  
                                        className={[Styles['hotspot-tabs'],'hotspot-tabs mb-0'].join(' ')}
                                    >
                                        
                                        {
                                            // check for exterior images
                                            this.state.isExterior ? (
                                                <Tab eventKey="exterior" title="Exterior">
                                                    <HotspotImageTabView 
                                                        imageList={this.state.imageListExterior} 
                                                        sliderSettings={sliderSettings}
                                                        imgLen={this.state.imageListExterior.length}
                                                    />
                                                </Tab>

                                            ):
                                            (<img src={`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne/AI/raw/fe362e01-f1fe-49d1-8744-af5e14e6167d.jpg`}  alt=""/>)
                                        }
                                        
                                        
                                    </Tabs>

                                    <p className={[Styles['simple-info-p']]}>
                                        Click the image to select a hotspot position.
                                    </p>
                                    <label>
                                        <span>Description*</span> 
                                        <input 
                                            type="text"
                                            defaultValue=""
                                            //onChange={this.handleDescUrlChange} 
                                            onBlur={this.handleUpdateDescURLHotspot2}
                                            //value={this.state.hotSpotDesc.desc}
                                            ref={this.hotSpotDescRefs.desc}
                                            placeholder="Explain a bit about the hotspot"
                                            id="desc-hotspot-input"
                                            style={{background: '#FFFFFF',border: '1px solid #E1E1E1', boxSizing: 'border-box', borderRadius: '5px'}}
                                        >
                                        </input>
                                    </label>

                                    <label><b>URL</b> 
                                        <input 
                                        type="text" 
                                            defaultValue=""
                                            //onChange={this.handleDescUrlChange} 
                                            onBlur={this.handleUpdateDescURLHotspot2}
                                            //value={this.state.hotSpotDesc.url}
                                            ref={this.hotSpotDescRefs.url}
                                            placeholder="Link to any image or video to showcase a feature"
                                            id="url-hotspot-input"
                                        >
                                        </input>
                                    </label>
                                    <form encType='multipart/form-data'>
                                        <label><b>Focus Shot</b> 
                                            <input type="file" name="hotSpotFocusShoot" id="hotSpotFocusShoot" onChange={this.handleImageChoice} accept="image/*"/>
                                        </label>
                                    </form>

                                </div>


                                
                            </div>
                        </div>
                    </div>


                    {
                        this.state.imageUploadInprogress ? <HotSpotChildComponentLoading /> : null
                    }
                    
                </div>
                </>
                }
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps)=>{
    //console.log({'state.hotspotReducer':state.hotspotReducer})
    return{
        hotSpotMapObj : state.hotspotReducer.hotSpotMapObj,
        hotSpotCount : state.hotspotReducer.hotSpotCount,
        currentImgObj : state.hotspotReducer.currentImageObj,
        currentImageRef : state.hotspotReducer.currentImageRefObj,
        hotSpotId : state.hotspotReducer.hotSpotId,
        currentHotSpotObj : state.hotspotReducer.currentHotSpotObj,
        syncHotSpotTitleDescURL : state.hotspotReducer.syncHotSpotTitleDescURL,
        projectIdAndSkuId : state.hotspotReducer.projectIdAndSkuId
    }
}

const mapDispatchToProps = (dispatch)=>{
    return {
        updateHotspot : (updatedHotSpot, imageId) => dispatch(updateHotspot(updatedHotSpot, imageId)),
        updateCurrentImage : (currentImageData) => dispatch(updateCurrentImage(currentImageData)),
        updateWholeHotSpotMapObj: (hotSpotMapObj) => dispatch(updateWholeHotSpotMapObj(hotSpotMapObj)),
        updateCurrentHotSpotId: (hotSpotId)=>dispatch(updateCurrentHotSpotId(hotSpotId)),
        upateSyncHotSpotTitleDescURL : (hotSpotId, titleDescURL) => dispatch(upateSyncHotSpotTitleDescURL(hotSpotId, titleDescURL)),
        updateWholeSyncHotSpotTitleDescURL : (syncHotSpotTitleDescURL) => dispatch(updateWholeSyncHotSpotTitleDescURL(syncHotSpotTitleDescURL)),
        updateProjectIdAndSkuId : (projectId, skuId) => dispatch(updateProjectIdAndSkuId(projectId, skuId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HotspotEdit);